module.exports = __webpack_public_path__ + "static/img/result-mobile-2.1bc9dc6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/result-mobile-2.png
// module id = VDK9
// module chunks = 1